import { render, staticRenderFns } from "./UploadMultiple.vue?vue&type=template&id=4220e9ce&"
import script from "./UploadMultiple.vue?vue&type=script&lang=js&"
export * from "./UploadMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports